<template>
  <div class="container pt-0">
    <v-row class="justify-center mb-4">
      <div
        v-if="facilityImageLinkValue"
        class="facility-image"
        :style="`background-image: url(' ${facilityImageLinkValue} ')`"
        :alt="facilityName"
      ></div>
      <template v-else></template>
    </v-row>
    <div class="container">
      <div v-for="(factoid, i) in facilityFactoids" :key="i">
        <template v-if="i === 0">
          <label class="overline mt-0 mb-2">{{ factoid.label }}</label>
          <h1 class="headline facility-title font-weight-bold mb-4">
            {{ factoid.value }}
          </h1>
        </template>
        <template v-else>
          <template v-show="factoid.value !== undefined">
            <template v-if="factoid.value.indexOf('www') === -1">
              <label class="overline mt-4">{{ factoid.label }}</label>
              <h2 class="subtitle-1 font-weight-bold mb-2">
                {{ factoid.value }}
              </h2>
            </template>
            <template v-else>
              <label class="overline mt-4">{{ factoid.label }}</label>
              <br />
              <a
                :href="
                  factoid.value.split('\n')[0].indexOf('://') > -1
                    ? factoid.value.split('\n')[0]
                    : 'http://' + factoid.value.split('\n')[0]
                "
                class="subtitle-1 font-weight-bold mb-2"
                target="_blank"
                >{{ factoid.value.split('\n')[0] }}</a
              >
              <template v-if="factoid.value.split('\n') > 1">
                <br />
                <a
                  :href="factoid.value.split('\n')[1]"
                  class="subtitle-1 font-weight-bold mb-2"
                  target="_blank"
                  >{{ factoid.value.split('\n')[1] }}</a
                >
              </template>
            </template>
          </template>
        </template>
      </div>
      <p>&nbsp;</p>
      <template v-if="facilityDisclaimer">
        <p class="caption font-weight-bold font-italic">
          {{ facilityDisclaimer }}
        </p>
      </template>
      <!-- <label class="overline mb-2">More Information</label>
      <p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          :href="facilityLinkToFactsheetValue"
        >Download Fact Sheet</a>
      </p>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'NavPanelFacility',
  computed: {
    ...mapState({
      facilityName: 'mapTemplate/selectedItemValue'
    }),
    ...mapGetters({
      facilityImageLinkValue: 'mapTemplate/facilityImageLinkValue',
      facilityLinkToFactsheetValue: 'mapTemplate/facilityLinkToFactsheetValue',
      facilityFactoids: 'mapTemplate/facilityFactoids',
      facilityDisclaimer: 'mapTemplate/facilityDisclaimer'
    })
  }
};
</script>

<style lang="scss" scoped>
.facility-image {
  width: 100%;
  min-height: 275px;
  background-repeat: no-repeat;
  background-size: cover;
}
.facility-title {
  color: #374d64;
}
</style>
